import { CustomerPortalRequestMessageAttachment } from "../../../api/models/unified";
import { MAIN_IMAGE_ROOT } from "../../../app_config";
import {
  // handleAttachmentThumbnailIconName,
  isImage,
} from "../../../helpers/attachmentsHelepr";
import AttachmentThumbnail from "../AttachmentThumbnail";

interface RequestAttachmentItemProps {
  attachment: CustomerPortalRequestMessageAttachment;
  handleOpenPreview: () => void;
}

const RequestAttachmentItem = ({
  attachment,
  handleOpenPreview,
}: RequestAttachmentItemProps) => {
  const handleAttachmentOnClick = () => {
    if (isImage(attachment)) {
      return handleOpenPreview();
    }

    window.open(`${MAIN_IMAGE_ROOT}${attachment.publicUrl}`, "_blank");
  };

  return (
    <div onClick={handleAttachmentOnClick} className="cursor-pointer">
      <AttachmentThumbnail
        // iconName={handleAttachmentThumbnailIconName(attachment)}
        attachment={attachment}
        isImage={isImage(attachment)}
      />
    </div>
  );
};

export default RequestAttachmentItem;
